module.exports = __webpack_public_path__ + "assets/img/teacher (12).aa348eb8.png";